import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

import { productAction } from "@redux/modules";
import PrivilegeCodeBox from "@components/PrivilegeCodeBox";

/**
 * Ayrıcalıklarım: üyenin aldığı ayrıcalık (0 puanlı) ürün kodları.
 * Kod, kopyala ve "Partner sitesinde kullan" butonlarıyla tekrar gösterilir.
 */
const Privileges = () => {
  const dispatch = useDispatch();
  const loginSettings = useSelector((store) => store.auth.loginSettings);

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    dispatch(productAction.getMyPrivileges())
      .then((res) => {
        if (active) setList(Array.isArray(res?.data) ? res.data : []);
      })
      .catch(() => {
        if (active) setFailed(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [dispatch]);

  return (
    <div className="bg-white shadow-lg rounded-3 p-sm-5 p-4">
      <h4 className="mb-1">Ayrıcalıklarım</h4>
      <p className="text-gray small mb-4">
        Aldığınız ayrıcalık kodları burada saklanır. Kodunuzu kopyalayıp partner
        sitesinde kullanabilirsiniz.
      </p>

      {loading && <p className="text-gray mb-0">Yükleniyor...</p>}

      {!loading && failed && (
        <p className="text-danger mb-0">
          Ayrıcalıklarınız yüklenemedi. Lütfen daha sonra tekrar deneyin.
        </p>
      )}

      {!loading && !failed && list.length === 0 && (
        <div className="text-center py-4">
          <p className="text-gray mb-3">Henüz bir ayrıcalık kodu almadınız.</p>
          <Link to="/shop" className="btn btn-green text-white rounded-pill px-4">
            Dükkana Git
          </Link>
        </div>
      )}

      {!loading && !failed && list.length > 0 && (
        <div className="d-flex flex-column gap-4">
          {list.map((item) => (
            <div
              key={`${item.productId}-${item.code}`}
              className="d-flex flex-sm-row flex-column gap-4 border rounded-3 p-3"
            >
              <Link
                to={`/shop/${item.productId}`}
                className="flex-shrink-0 d-flex align-items-center justify-content-center bg-light rounded-3"
                style={{ width: 120, height: 120 }}
              >
                <img
                  src={item.productImage || loginSettings?.logo}
                  alt={item.productName}
                  className="img-contain"
                  style={{ maxWidth: 110, maxHeight: 110 }}
                />
              </Link>
              <div className="flex-grow-1">
                <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
                  <Link
                    to={`/shop/${item.productId}`}
                    className="h6 mb-0 text-decoration-none text-gray-darkest"
                  >
                    {item.productName}
                  </Link>
                  {item.assignedDate && (
                    <span className="small text-gray">
                      {moment(item.assignedDate).format("DD.MM.YYYY HH:mm")}
                    </span>
                  )}
                </div>
                <PrivilegeCodeBox
                  productId={item.productId}
                  code={item.code}
                  partnerUrl={item.partnerUrl}
                  compact
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Privileges;
